var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeletePopup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 48,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fill: "#ff8181",
    d: "M24.5 2L24.5 2C36.95 2 47 12.06 47 24.5L47 24.5C47 36.95 36.95 47 24.5 47L24.5 47C12.06 47 2 36.95 2 24.5L2 24.5C2 12.06 12.06 2 24.5 2Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fill: "#ffffff",
    d: "M18.85 30.65C18.86 30.89 18.92 31.12 19.02 31.34C19.12 31.55 19.26 31.75 19.43 31.91C19.61 32.08 19.81 32.2 20.04 32.29C20.26 32.37 20.5 32.41 20.74 32.4L28.26 32.4C28.5 32.41 28.74 32.37 28.96 32.29C29.19 32.2 29.39 32.08 29.57 31.91C29.74 31.75 29.88 31.55 29.98 31.34C30.08 31.12 30.14 30.89 30.15 30.65L30.15 20.11L18.85 20.11L18.85 30.65ZM31.09 17.47L27.79 17.47L26.85 16.6L22.15 16.6L21.21 17.47L17.91 17.47L17.91 19.23L31.09 19.23L31.09 17.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fill: "none",
    d: "M14.62 14.62L34.38 14.62L34.38 34.38L14.62 34.38L14.62 14.62Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletePopup);
export default __webpack_public_path__ + "static/media/deletePopup.210c3c5e.svg";
export { ForwardRef as ReactComponent };